import { TAccountNavigationMenuItem } from '@pb/shared/ui/molecules/account-navigation-menu';

export const mockNavigationMenuItems: TAccountNavigationMenuItem[] = [
    {
        label: 'Dashboard',
        icon: 'home',
        href: '#',
    },
    {
        label: 'Properties',
        icon: 'soldBoard',
        children: [
            { href: '#', label: 'Your properties' },
            { href: '#', label: 'Book a valuation' },
        ],
    },
];
